import { UseCustomerIdQuery } from './__generated__/useCustomerId'

export const getCustomerId = (
  customerData?: UseCustomerIdQuery,
): string | undefined => {
  return customerData?.me?.customer?.id || undefined
}
